import { Outlet } from 'react-router-dom';
import { Suspense } from 'react';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { BottomNav } from './BottomNav';
import { Eye } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const PageLoader = () => (
  <div className="flex items-center justify-center h-64">
    <img src="/isologo-azul.png" alt="" className="w-10 h-10 object-contain animate-pulse" />
  </div>
);

const BrandFooter = () => (
  <footer
    className="hidden md:flex items-center justify-center gap-2 py-3 px-6 border-t border-border/60 bg-white/80 backdrop-blur-sm shrink-0"
    data-testid="brand-footer"
  >
    <img src="/isologo-azul.png" alt="" className="h-4 w-4 object-contain opacity-80" />
    <span
      className="text-[11px] tracking-[0.06em] text-[#052f6b]/80 font-semibold italic"
      style={{ fontFamily: "'Libre Baskerville', Georgia, serif" }}
      data-testid="brand-footer-slogan"
    >
      Tu Bienestar es Nuestro Horizonte
    </span>
    <span className="text-[10px] text-muted-foreground ml-2">
      © Seguros Horizonte, S.A.
    </span>
  </footer>
);

export const AppShell = () => {
  const { isReadOnly, user } = useAuth();
  return (
    <div className="flex h-screen bg-background" data-testid="app-shell">
      {/* Sidebar - hidden on mobile */}
      <div className="hidden md:block">
        <Sidebar />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden min-w-0">
        {isReadOnly && (
          <div
            className="flex items-center justify-center gap-2 py-1.5 px-4 bg-amber-100 border-b border-amber-300 text-amber-900 text-xs font-medium"
            data-testid="read-only-banner"
          >
            <Eye className="w-3.5 h-3.5" />
            <span>
              MODO CONSULTA — sesión de auditoría externa ({user?.email}). Todas las acciones de escritura están deshabilitadas.
            </span>
          </div>
        )}
        <Topbar />

        <main className="flex-1 overflow-y-auto px-4 py-4 sm:p-4 md:p-6 pb-[calc(var(--bottomnav-height)+1.5rem)] md:pb-6">
          <Suspense fallback={<PageLoader />}>
            <Outlet />
          </Suspense>
        </main>

        <BrandFooter />
      </div>

      {/* Bottom Nav - mobile only */}
      <BottomNav />
    </div>
  );
};
